<template>
  <div class="delete-confirmation">
    <p class="delete-confirmation-copy">Är du säker på att du vill ta bort meddelandet?</p>
    <p v-if="preview" class="delete-confirmation-preview">
      {{ preview }}
    </p>

    <div class="delete-confirmation-actions">
      <AppButton :disabled="isConfirming" @click="emit('close')">Avbryt</AppButton>
      <AppButton color="red" :loading="isConfirming" @click="confirm">Ta bort</AppButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import AppButton from '../AppButton/AppButton.vue'

const props = defineProps<{
  preview: string
  onConfirm: () => void | Promise<void>
}>()

const emit = defineEmits<{
  (event: 'close'): void
}>()

const isConfirming = ref(false)

const confirm = async () => {
  if (isConfirming.value) return

  isConfirming.value = true
  try {
    await props.onConfirm()
  } finally {
    isConfirming.value = false
  }
}
</script>

<style scoped lang="scss">
.delete-confirmation {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 0 16px;
}

.delete-confirmation-copy,
.delete-confirmation-preview {
  margin: 0;
}

.delete-confirmation-preview {
  padding: 12px;
  border-radius: 12px;
  background-color: var(--color-canvas-subtle);
  color: var(--color-fg-subtle);
  white-space: pre-wrap;
  line-height: 1.5;
}

.delete-confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
